import React from 'react';
import { excuses, interruptions } from '../data/salesPage';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-t border-ink-line bg-ink-raised" data-id="element-199" data-mp="2lt32kkahhhb9">
      <div className="mx-auto max-w-5xl px-5 py-20 sm:py-28" data-id="element-200" data-mp="30hhctga8c81u">
        <h2 id="problema" className="max-w-3xl font-display text-4xl font-black uppercase leading-[1.02] text-bone sm:text-6xl" data-id="element-201" data-mp="30j0vfdjcyv6s">
          ¿Cuántas veces empezaste y terminaste <span className="text-lime" data-id="element-202" data-mp="39gb3yr4sk680">abandonando?</span>
        </h2>

        <div className="mt-14 grid gap-14 lg:grid-cols-[1.15fr_1fr] lg:gap-20" data-id="element-203" data-mp="35h2alndnyacz">
          <div data-id="element-204" data-mp="3jftmd351zjxy">
            <p className="text-lg text-bone-muted" data-id="element-205" data-mp="3jgbtwvx61kl6">Probablemente ya probaste alguna de estas cosas:</p>
            <ul className="mt-6 space-y-3" data-id="element-206" data-mp="3egpc096e7g61">
              {excuses.map(excuse => <li key={excuse} className="border-l-2 border-lime/60 pl-5 font-display text-xl font-bold text-bone sm:text-2xl" data-id="element-207" data-mp="1p1iyawwa8tt8">
                  “{excuse}”
                </li>)}
            </ul>
            <p className="mt-8 text-lg text-bone-muted" data-id="element-208" data-mp="je6cwrhly658">Y durante algunos días funciona.</p>
          </div>

          <div data-id="element-209" data-mp="od9g06e122ak">
            <p className="text-lg text-bone-muted" data-id="element-210" data-mp="ocpxookgtbw0">Hasta que aparece:</p>
            <ul className="mt-6 flex flex-wrap gap-2.5" data-id="element-211" data-mp="scqqje8b9pml">
              {interruptions.map(item => <li key={item} className="rounded-full border border-ink-line bg-ink px-4 py-2 text-base font-medium text-bone" data-id="element-212" data-mp="x5js5t8hghug">
                  {item}
                </li>)}
            </ul>
            <div className="mt-12" data-id="element-213" data-mp="171egn4ze1755">
              <p className="text-lg text-bone-muted" data-id="element-214" data-mp="174iteqqx5b7f">Y de repente…</p>
              <p className="mt-2 font-display text-3xl font-black uppercase leading-tight text-alert sm:text-4xl" data-id="element-215" data-mp="1c2aize43cl8g">
                volvés al punto de partida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}